import React, { Component } from 'react';
import LinkedIn from '../../images/social/in.png';
import Facebook from '../../images/social/fb.png';
import Instagram from '../../images/social/inst.png';
import Twitter from '../../images/social/tw.png';

class Social extends Component {

  render() {
    return (
      <nav className='social text-align-right flex-group flex-end'>
        <a href='#linkedin'><img src={LinkedIn} alt="" /></a>
        <a href='#facebook'><img src={Facebook} alt="" /></a>
        <a href='#instagram'><img src={Instagram} alt="" /></a>
        <a href='#twitter'><img src={Twitter} alt="" /></a>
      </nav>
    );
  }
}

export default Social;
